import type { TextFieldProps } from "@shopify/polaris";
import type { IPurchaseOrderLineItem } from "../../../api_utils/types";

export const dutyColumns = [
  { id: "entry_summary_line_number", title: "Entry summary line number", type: "number", step: 1, width: "96px" },
  { id: "description_of_goods", title: "Description of goods", type: "text", width: "320px" },
  { id: "classification_number", title: "Classification number", type: "text", width: "144px" },
  { id: "duty_rate", title: "Duty rate", type: "number", suffix: "%", step: 0.01, width: "112px" },
] satisfies ({ id: keyof IPurchaseOrderLineItem; title: string; width: string } & Pick<TextFieldProps, "type" | "suffix" | "step">)[];
